import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'formly-readonly-item',
  template: `
    @if (isObject(data)) {
      <div>
        @for (key of objectKeys(data); track key) {
          <div>
            <strong>{{ key }}:</strong>
            <formly-readonly-item [class]="field.props?.className" [data]="data[key]"></formly-readonly-item>
          </div>
        }
      </div>
    }
    @if (isArray(data)) {
      <ul>
        @for (item of data; track item) {
          <li>
            <formly-readonly-item [class]="field.props?.className" [data]="item"></formly-readonly-item>
          </li>
        }
      </ul>
    }
    @if (!isObject(data) && !isArray(data)) {
      <span>{{ data }}</span>
    }
    @if (field.props?.description) {
      <mat-hint class="inline-block mb-2">{{ field.props?.description }}</mat-hint>
    }
  `,
  imports: [
    ReactiveFormsModule,
    MatAutocompleteModule,
    FormlyModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
  ],
  styles: `
    .readonly-object {
      padding: 10px;
      border-radius: 4px;
    }
    .nested {
      margin-left: 20px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldReadonlyField extends FieldType {
  @Input() data: any;
  constructor() {
    super();
  }

  isObject(val: any): boolean {
    return val && typeof val === 'object' && !Array.isArray(val);
  }

  isArray(val: any): boolean {
    return Array.isArray(val);
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }
}
